<template>
  <div v-if="showThemeToggle" class="toggle-mode" :class="{toggled: themeMode === 'dark' }" @click="toggleThemeMode()">
    <div class="toggle-moon">🌛</div>
    <div class="toggle-sun">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M9.99984 13.3333C11.8408 13.3333 13.3332 11.8409 13.3332 9.99996C13.3332 8.15901 11.8408 6.66663 9.99984 6.66663C8.15889 6.66663 6.6665 8.15901 6.6665 9.99996C6.6665 11.8409 8.15889 13.3333 9.99984 13.3333Z" stroke="#1f2933" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M2.5 10H3.33333M10 2.5V3.33333M16.6667 10H17.5M10 16.6667V17.5M4.66667 4.66667L5.25 5.25M15.3333 4.66667L14.75 5.25M14.75 14.75L15.3333 15.3333M5.25 14.75L4.66667 15.3333" stroke="#1f2933" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <div class="toggle-thumb"></div>
  </div>
</template>

<script>
import theme from '@/mixins/theme'

export default {
  mixins: [theme]
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
.toggle-mode {
  background-color: #d8d8d8;
  border-radius: 30px;
  cursor: pointer;
  display: flex;
  height: 24px;
  position: relative;
  user-select: none;
  width: 40px;
}

.toggle-sun {
  align-items: center;
  display: flex;
  font-size: 12px;
  padding: 0.125rem;
  width: 50%;
}
.toggle-moon {
  align-items: center;
  display: flex;
  font-size: 12px;
  padding: 0 4px;
  width: 50%;
}

.toggle-moon {
  justify-content: flex-end;
}

.toggle-thumb {
  background-color: #fff;
  border-radius: 50%;
  height: 17.75px;
  left: 3px;
  position: absolute;
  top: 3px;
  transition: transform .5s cubic-bezier(.23,1,.32,1);
  width: 18px;
}

.toggle-mode.toggled .toggle-thumb {
  transform: translateX(16px);
}
.toggle-mode.toggled {
  background-color: #1f2933;
}
</style>
